import { queryOptions } from "@tanstack/react-query";
import { getPostBySlug } from "./blog.functions";
import { HAIL_ARTICLE_SLUG } from "./hail-content";

export const hailArticleQuery = queryOptions({
  queryKey: ["blog", "post", HAIL_ARTICLE_SLUG],
  queryFn: () => getPostBySlug({ data: { slug: HAIL_ARTICLE_SLUG } }),
  staleTime: 60_000,
});